import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { OfferPanel } from '../OfferPanel';
export function Urgency() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-311" data-mp="2fjilm9p53mwl">
      <SectionHeading eyebrow="Don’t miss your special offer" title="Take the Next Step Toward More Structured Torque Planning" lede="Instead of approaching difficult root movements without a clear process, start using a practical clinical framework to organize your decisions. Your complete library is available for $27." data-id="element-312" data-mp="2biyo350nmh9x" />
      <div className="mx-auto mt-10 max-w-xl" data-id="element-313" data-mp="2zb5pwjp5fggq">
        <OfferPanel ctaLabel="Get my Torque Control Blueprint for $27" data-id="element-314" data-mp="2uht4sjjohrsq" />
      </div>
    </section>;
}